import { Box, Button, Container, useMediaQuery, useTheme } from "@mui/material";
import { TypeAnimation } from "react-type-animation";
import imgE from '../assets/imgE.png';
import imgF from '../assets/ImgF.png';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const images = [
    imgE,
    imgF
];

function IntroBanner() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const navigate = useNavigate();

    const [currentImage, setCurrentImage] = useState(0);
    const imageCount = images.length;
  

    // Auto-scrolling functionality
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImage((prevImage) => (prevImage === imageCount - 1 ? 0 : prevImage + 1));
      }, 3000); // 3-second interval
      return () => clearInterval(interval); // Clean up interval
    }, [currentImage]);
  
    return (
      <Container
          id="home"
          sx={{
            display: "flex",
            flexDirection: {xs: 'column', md: 'row'},
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: {xs: 2, md: 5},
          }}
      >

        <Box
          sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: {xs: '10px'},
              marginTop: {xs: 5},
              padding: { xs: 1, sm: 4 },
          }}
        >
        <Box sx={{ padding: 2}}>
          <TypeAnimation
              sequence={[
                  'Less Drugs',
                  1000,
                  'Less Drugs More Food.',
                  1000,
                  'Less Drugs',
                  1000,
                  'Less Drugs Healthier Life!',
                  1000,
              ]}
              wrapper="span"
              speed={50}
              style={{
              fontSize: isMobile ? '1.7em' : '3em',
              display: 'inline-block',
              fontFamily: '"Fredoka One", sans-serif', // Cartoonish font
              color: '#c4310c', // Bright, playful color
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)', // Fun shadow effect
              }}
              repeat={Infinity}
          />
        </Box>

        {/* <Box display="flex" justifyContent={{xs: 'center', md: 'start'}}>
            <Button
                variant="contained"
                color="primary"
                sx={{
                    backgroundColor: "#060b96",
                    '&:hover': { backgroundColor: "rgba(0, 0, 0, 1)" }
                }}
                onClick={() => navigate("/shop")}
            >
                Get Started
            </Button>
        </Box> */}


        </Box>

      <Box
        sx={{
          width: "100%",
          height: { xs: 300, md: 500 },
          overflow: "hidden",
          backgroundImage: `url(${images[currentImage]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: 5,
          marginTop: 5
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 20,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: 2,
            zIndex: 2,
            alignItems: "center",
          }}
        >
          {images.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: currentImage === index ? "white" : "rgba(255, 255, 255, 0.6)",
                transition: "background-color 0.3s",
              }}
            />
          ))}
        </Box>
      </Box>

         
      </Container>
    );
};

export default IntroBanner;